import script from "./FamilyGroupItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyGroupItem.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyGroupItem.vue?vue&type=style&index=0&id=915942c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-915942c4"]])

export default __exports__